import { ChangeEvent, FC, useEffect, useState } from "react";
import EditInputField from "../edit-input-field/EditInputField";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import {
  createUser,
  getAllOrganizations,
} from "../../../redux/requests/AdminRequests";

interface IAddOperatorModalProps {
  isActive: boolean;
  setIsActive: Function;
  ref: any;
}

const AddOperatorModal: FC<IAddOperatorModalProps> = ({
  isActive,
  ref,
  setIsActive,
}) => {
  const dispatch = useAppDispatch();
  const organizations = useAppSelector((state) => state.admin.organizations);
  const operator = useAppSelector((state) => state.user.operator);

  useEffect(() => {
    dispatch(getAllOrganizations());
  }, []);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [fullname, setFullname] = useState<string>("");
  const [orgId, setOrgId] = useState<number | undefined>(undefined);

  const onSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    try {
      setOrgId(Number(event.target.value));
    } catch (error) {
      console.log(error);
    }
  };

  const onAddUserClick = () => {
    if (!username.trim() || !password.trim() || !orgId || !fullname.trim())
      return;

    if (!operator) return;

    dispatch(
      createUser({
        created_by: operator.id,
        fullname: fullname,
        org_id: orgId,
        password: password,
        username: username,
      })
    ).then((data) => {
      if (!data) return;
      setIsActive(false);
    });
  };

  return (
    <div
      tabIndex={-1}
      className={`${
        isActive ? "" : "hidden"
      } overflow-y-auto overflow-x-hidden absolute z-50 items-center md:inset-0 h-full w-full flex justify-center align-middle`}
    >
      <div
        className="relative p-4 w-full max-w-md max-h-full bg-white"
        ref={ref}
      >
        <div className="relative bg-neutral-primary-soft border border-default rounded-base shadow-sm p-4 md:p-6">
          <div className="flex items-center justify-between border-b border-default pb-4 md:pb-5">
            <h3 className="text-lg font-medium text-heading">
              Добавление оператора
            </h3>
            <button
              type="button"
              className="text-body bg-transparent hover:bg-neutral-tertiary hover:text-heading rounded-base text-sm w-9 h-9 ms-auto inline-flex justify-center items-center"
              onClick={() => setIsActive(false)}
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="pt-4 md:pt-6">
            <EditInputField
              data={{
                id: 52,
                labelText: "username",
                type: "text",
                value: username,
              }}
              setValue={setUsername}
              readonly={false}
            />
            <EditInputField
              data={{
                id: 53,
                labelText: "password",
                type: "password",
                value: password,
              }}
              setValue={setPassword}
              readonly={false}
            />
            <EditInputField
              data={{
                id: 54,
                labelText: "fullname",
                type: "text",
                value: fullname,
              }}
              setValue={setFullname}
              readonly={false}
            />
            <label
              htmlFor="countries"
              className="block mb-2.5 text-sm font-medium text-heading  mt-4"
            >
              organization
            </label>
            <select
              id="countries"
              className="block w-full px-3 py-2.5 bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand shadow-xs placeholder:text-body"
              onChange={onSelectChange}
            >
              <option selected>Choose an organization</option>
              {organizations.map((org, index) => {
                return (
                  <option value={org.id} key={index}>
                    {org.name}
                  </option>
                );
              })}
            </select>
          </div>
          <button
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none w-full mt-4"
            onClick={onAddUserClick}
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOperatorModal;
